import React from 'react';
import { Box } from '@mui/material';
import Navigation from './Navigation';
import Footer from './Footer';

const MainLayout = ({ children, hideFooter = false }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navigation />
      <Box component="main" sx={{ flexGrow: 1 }}>
        {children}
      </Box>
      {!hideFooter && <Footer />}
    </Box>
  );
};

export default MainLayout;
